
define(
  'PlpSalesDescription.EntryPoint',
  ['underscore']
  , function (
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {

        var plp = container.getComponent('PLP');

        if (plp) {
          plp.addToViewContextDefinition('Facets.ItemCell.View', 'salesDescription', 'string', function (context) {
            var salesDescription = '';
            var itemsInfo = plp.getItemsInfo();
            _.each(itemsInfo, function (item) {
              if (item.internalid === context.itemId) {
                salesDescription = item.featureddescription;
              }
            });
            return salesDescription;
          });
        }
      }
    };
  });
